/** The page locale, then the browser locale, with English as the final fallback. */
export function siteLocale() {
    return validLocale(document.documentElement.lang) || validLocale(navigator.language) || 'en';
}

function validLocale(locale) {
    if (typeof locale !== 'string' || !locale.trim()) return null;

    const normalized = locale.trim().replace(/_/g, '-');
    if (normalized.toLowerCase() === 'auto') return null;

    try {
        if (typeof Intl !== 'undefined' && Intl && typeof Intl.getCanonicalLocales === 'function') {
            return Intl.getCanonicalLocales(normalized)[0];
        }
        // Native locale methods can validate tags when the Intl global is absent.
        ''.localeCompare('', normalized);
        return normalized;
    } catch {
        return null;
    }
}
